/* eslint-disable no-bitwise */

import { UntypedFormGroup } from "@angular/forms";
import { Cellstyle } from "~app/common/components/hot-doc/hotdoc/cell";
import { HotDoc } from "~app/common/components/hot-doc/hotdoc/doc";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { ProduktmatrisGrid } from "../../produktinstruktioner-details/matris/ProduktmatrisGrid";
import { DistributionCell } from "../../produktinstruktioner-details/matris/cells/distributionCell";
import { SumPercentSummaryCell } from "../../produktinstruktioner-details/matris/cells/sumPercentSummaryCell";
import { ProduktdefinitionHeaderData } from "../ProduktdefinitionHeaderData";
import { LangdDiameterMatris } from "./LangdDiameterMatris";

export class Fordelningsmatris extends LangdDiameterMatris {
    constructor(grid: ProduktmatrisGrid,
        form: UntypedFormGroup,
        headerData: ProduktdefinitionHeaderData,
        canEdit: boolean) {
        super(grid, form, headerData, canEdit);
    }

    getFordelningsmatris(raskModalService: RaskModalService, form: UntypedFormGroup): HotDoc {
        const colFactory = () => this.buildColumnDefinitions({ readOnly: !this.canEdit,
            type: "numeric" });
        const rowFactory = (doc: HotDoc) => this.buildRowDefinitions(
            doc,
            {
                cellFactory: (pmData) => new DistributionCell(pmData, form, Cellstyle.Default | Cellstyle.AlignCenter),
                columnSummaryFactory: (cells) => new SumPercentSummaryCell(cells, true),
                rowSummaryFactory: (cells) => new SumPercentSummaryCell(cells, false),
                sumOfSumsFactory: (cells) => new SumPercentSummaryCell(cells, false)
            }, raskModalService, false);

        const settingsFactory = (doc: HotDoc) => this.getBaseSettings(doc, raskModalService);

        return new HotDoc(colFactory, rowFactory, settingsFactory);
    }

}
